<template>
    <wrapper title="Nihom">
            <div class="row center" v-if="loading">
                <pre-loader></pre-loader>
            </div>
            <div class="container" v-else>
                <div class="row header_container">
                    <h6>{{ data.type.name }}</h6>
                </div>
                <div class="row">
                     <item v-for="item in data.contents" :key="item.id" :data="item"></item>
                </div>
                
            </div>
    </wrapper>
</template>
<script>
import Item from './Item.vue';
export default {
    components: 
    {
        "item":Item
    },
    mounted() {
        this.$store.dispatch("getNihomContent",{type_id:this.$route.params.id});
    },
    computed: {
        data()
        {
             return this.$store.getters.nihom_contents;
        },
        loading()
        {
            return this.$store.getters.nihom_content_loading;
        }
    },
}
</script>
<style lang="scss" scoped>
        .container 
        {
            padding-top:20px;
        }

        .header_container h6 
        {
            font-size:20px;
            text-transform:uppercase;
            color:#005555;
            border-bottom:3px solid #005555 !important;
            padding-left:20px;
            padding-bottom:15px;
            
        }

</style>